//eslint-disable-next-line @typescript-eslint/naming-convention
export const PayPalPaymentMethodName = "PayPal";
//eslint-disable-next-line @typescript-eslint/naming-convention
export const PayPalConfigName = "paypal";
//eslint-disable-next-line @typescript-eslint/naming-convention
export const PayLaterFundingSourceName = "paylater";
//eslint-disable-next-line @typescript-eslint/naming-convention
export const PayPalFundingSourceName = "paypal";
